"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AgreementEditorContextProvider = exports.AgreementConfirmDelete = void 0;
var react_1 = __importStar(require("react"));
var GetBlockModels_1 = require("@CommonFrontendBackend/BlockModels/GetBlockModels");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var BlockTypes_1 = require("@CommonFrontendBackend/BlockModels/BlockTypes");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var inversify_react_1 = require("inversify-react");
var styles = __importStar(require("./AgreementButton.css"));
var AcceptBlockStore_1 = __importDefault(require("Project/Modules/Accept/AcceptBlockStore"));
var AngularSyncStore_1 = require("@CommonFrontend/Utils/AngularSyncStore");
var DIProvider_1 = __importStar(require("@CommonFrontend/DIProvider/DIProvider"));
var inversify_1 = require("inversify");
var mobx_react_1 = require("mobx-react");
var AcceptPreviewEventEmitter_1 = require("../AcceptPreviewEventEmitter");
var generateThumbnailId_1 = require("@CommonFrontendBackend/SavedBlocks/generateThumbnailId");
var block_agreement_placeholder_svg_1 = __importDefault(require("@ClientAssets/icons/block-agreement-placeholder.svg"));
var utils_1 = require("@qwilr/kaleidoscope/utils");
var Configuration_1 = require("@CommonFrontend/Styles/Configuration/Configuration");
var EditActionBarStore_1 = __importDefault(require("Project/BlockNew/SavedBlocks/ContentEditor/EditActionBar/EditActionBarStore"));
var SaveOrchestrator_1 = require("Project/BlockNew/SavedBlocks/ContentEditor/SaveOrchestrator");
var TelemetryEnums_1 = require("@CommonFrontend/Telemetry/TelemetryEnums");
var lodash_1 = require("lodash");
var Promptable_1 = require("Common/Prompt/Promptable");
var PromptTypes_1 = require("@CommonFrontend/Prompt/PromptTypes");
var MaybeWrap_1 = __importDefault(require("@CommonFrontend/Utils/MaybeWrap"));
var FeatureFlag_1 = __importDefault(require("@CommonFrontendBackend/FeatureFlag"));
var AgreementCard = function (_a) {
    var onClick = _a.onClick, savedBlockName = _a.savedBlockName, thumbnailUrl = _a.thumbnailUrl;
    var _b = __read((0, react_1.useState)(true), 2), thumbnailLoaded = _b[0], setThumbnailLoaded = _b[1];
    var Thumbnail = function () {
        if (!!thumbnailUrl) {
            if (thumbnailLoaded) {
                return (react_1.default.createElement("img", { src: thumbnailUrl, className: styles.thumbnail, onError: function () {
                        setThumbnailLoaded(false);
                    }, onLoad: function () {
                        setThumbnailLoaded(true);
                    } }));
            }
            else {
                return (react_1.default.createElement(kaleidoscope_1.Stack, { justify: "center", align: "center", gap: "s" },
                    react_1.default.createElement("div", { className: styles.thumbnailPlaceholderImage },
                        react_1.default.createElement(kaleidoscope_1.SVG, { src: block_agreement_placeholder_svg_1.default })),
                    react_1.default.createElement(kaleidoscope_1.Label, { size: "s", secondary: true }, "Preview loading")));
            }
        }
        else {
            return react_1.default.createElement(kaleidoscope_1.Stack, { justify: "center", align: "center", gap: "s" });
        }
    };
    var key = "saved-agreement-".concat((0, utils_1.randomString)());
    return (react_1.default.createElement(kaleidoscope_1.Stack, { gap: "xxs", align: "center" },
        react_1.default.createElement(kaleidoscope_1.ButtonCard, { elevation: 0, onClick: onClick, "aria-labelledby": key, className: styles.buttonCard({ thumbnailLoaded: thumbnailLoaded }) },
            react_1.default.createElement(Thumbnail, null)),
        react_1.default.createElement(kaleidoscope_1.Text, { size: "s", strong: true, id: key, className: styles.agreementCardLabel }, savedBlockName)));
};
var AddAgreementButton = function (_a) {
    var onClick = _a.onClick, isAgreementPickerOpen = _a.isAgreementPickerOpen, setIsAgreementPickerOpen = _a.setIsAgreementPickerOpen, shouldShowPrompt = _a.shouldShowPrompt;
    var thumbnailApiBaseUrl = (0, inversify_react_1.useInjection)("thumbnailApiBaseUrl");
    var account = (0, inversify_react_1.useInjection)("account");
    var savedBlockApiService = (0, inversify_react_1.useInjection)("savedBlockApiService");
    var useHistoryDataStore = (0, inversify_react_1.useInjection)("rootDataStore").userDataStore.useHistoryDataStore;
    var _b = __read((0, react_1.useState)([]), 2), savedBlocks = _b[0], setSavedBlocks = _b[1];
    var getThumbnailUrl = function (savedBlockId) {
        var savedBlockThumbnailId = (0, generateThumbnailId_1.generateThumbnailId)(account._id, savedBlockId);
        return "".concat(thumbnailApiBaseUrl, "/v1/artefact/").concat(savedBlockThumbnailId, "/thumbnail");
    };
    (0, react_1.useEffect)(function () {
        function fetchSavedBlocks() {
            return __awaiter(this, void 0, void 0, function () {
                var response, sortedBlocks, err_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            return [4, savedBlockApiService.getSavedBlockByBlockType(BlockTypes_1.BlockType.Agreement)];
                        case 1:
                            response = _a.sent();
                            if (response) {
                                sortedBlocks = (0, lodash_1.orderBy)(response, ["createdAt"], ["desc"]);
                                setSavedBlocks(sortedBlocks);
                            }
                            return [3, 3];
                        case 2:
                            err_1 = _a.sent();
                            console.error("Unable to fetch saved agreement blocks", err_1);
                            return [3, 3];
                        case 3: return [2];
                    }
                });
            });
        }
        fetchSavedBlocks();
    }, [savedBlockApiService]);
    return (react_1.default.createElement(kaleidoscope_1.AngularOverlayProvider, null,
        react_1.default.createElement(kaleidoscope_1.Popover, { maxHeight: 484, caret: true, isOpen: isAgreementPickerOpen, onChange: setIsAgreementPickerOpen, padding: "none", className: styles.popover, size: kaleidoscope_1.PopoverSize.Auto, autoStack: true, button: function (buttonProps) { return (react_1.default.createElement(MaybeWrap_1.default, { wrapper: function (children) {
                    if (shouldShowPrompt) {
                        return react_1.default.createElement(Promptable_1.Promptable, { id: PromptTypes_1.PromptId.AddAgreement }, children);
                    }
                    return children;
                } },
                react_1.default.createElement(kaleidoscope_1.Button, __assign({ type: kaleidoscope_1.ButtonType.Tertiary, size: kaleidoscope_1.ButtonSize.Small }, buttonProps, { onClick: function (event) {
                        useHistoryDataStore.clickedPrompt(PromptTypes_1.PromptId.AddAgreement);
                        buttonProps.onClick(event);
                    } }),
                    react_1.default.createElement(icons_1.Add, null),
                    " Add Agreement"))); } },
            react_1.default.createElement(kaleidoscope_1.Stack, { direction: "horizontal", justify: "center", align: "center", paddingLeft: "l", paddingRight: "l", paddingTop: "l" },
                react_1.default.createElement(kaleidoscope_1.Heading, { level: "4" }, "Choose an agreement"),
                react_1.default.createElement(kaleidoscope_1.IconButton, { icon: react_1.default.createElement(icons_1.Close, null), className: styles.closeButton, onClick: function () { return setIsAgreementPickerOpen(false); } })),
            react_1.default.createElement("div", { className: styles.gridContainer },
                react_1.default.createElement(AgreementCard, { savedBlockName: "Blank agreement", onClick: onClick, key: "blank" }),
                savedBlocks.map(function (block, idx) { return (react_1.default.createElement(AgreementCard, { key: idx, savedBlockName: block.savedBlockName, thumbnailUrl: getThumbnailUrl(block.id), onClick: function (event) { return onClick(event, block); } })); })))));
};
var AgreementOptionsMenu = (0, mobx_react_1.observer)(function (_a) {
    var onClickDelete = _a.onClickDelete, openAgreementPicker = _a.openAgreementPicker;
    var isSavedBlocksLibrary = useAgreementEditorContext().isSavedBlocksLibrary;
    return (react_1.default.createElement(kaleidoscope_1.Stack, { gap: "xxs", padding: "xxs" },
        !isSavedBlocksLibrary && (react_1.default.createElement(kaleidoscope_1.Button, { isDestructive: true, type: kaleidoscope_1.ButtonType.Tertiary, className: styles.menuButton, onClick: function () {
                onClickDelete();
                openAgreementPicker();
            } },
            react_1.default.createElement(kaleidoscope_1.Stack, { direction: "horizontal", gap: "xs" },
                react_1.default.createElement(icons_1.Swap, { size: icons_1.IconSize.Medium, className: styles.icon }),
                react_1.default.createElement(kaleidoscope_1.Text, { strong: true, size: "s", className: styles.menuButtonText }, "Change agreement")))),
        react_1.default.createElement(kaleidoscope_1.Button, { isDestructive: true, type: kaleidoscope_1.ButtonType.Tertiary, className: styles.menuButton, onClick: onClickDelete },
            react_1.default.createElement(kaleidoscope_1.Stack, { direction: "horizontal", gap: "xs" },
                react_1.default.createElement(icons_1.Delete, { size: icons_1.IconSize.Medium, className: styles.icon }),
                react_1.default.createElement(kaleidoscope_1.Text, { strong: true, size: "s", className: styles.menuButtonText }, "Delete agreement")))));
});
var AgreementConfirmDelete = function (_a) {
    var onConfirm = _a.onConfirm, onCancel = _a.onCancel;
    var isSavedBlocksLibrary = useAgreementEditorContext().isSavedBlocksLibrary;
    return (react_1.default.createElement(kaleidoscope_1.Stack, { gap: "xs", padding: "m" },
        react_1.default.createElement(kaleidoscope_1.Text, { strong: true, size: "s" }, "Delete agreement"),
        react_1.default.createElement(kaleidoscope_1.Text, { size: "s" }, isSavedBlocksLibrary
            ? "Remove this agreement permanently from this block?"
            : "Remove this agreement permanently from this Qwilr page?"),
        react_1.default.createElement(kaleidoscope_1.Stack, { direction: "horizontal", gap: "xs" },
            react_1.default.createElement(kaleidoscope_1.Button, { type: kaleidoscope_1.ButtonType.Secondary, size: kaleidoscope_1.ButtonSize.Small, onClick: onCancel }, "Cancel"),
            react_1.default.createElement(kaleidoscope_1.Button, { size: kaleidoscope_1.ButtonSize.Small, isDestructive: true, onClick: onConfirm }, "Delete"))));
};
exports.AgreementConfirmDelete = AgreementConfirmDelete;
var EditAgreementButton = (0, mobx_react_1.observer)(function (_a) {
    var openAgreementPicker = _a.openAgreementPicker;
    var acceptBlockStore = (0, inversify_react_1.useInjection)(AcceptBlockStore_1.default);
    var _b = __read((0, react_1.useState)("options"), 2), screen = _b[0], setScreen = _b[1];
    var _c = useAgreementEditorContext(), openAgreement = _c.openAgreement, deleteAgreement = _c.deleteAgreement;
    (0, react_1.useEffect)(function () {
        if (!acceptBlockStore.agreementId) {
            setScreen("options");
        }
    }, [acceptBlockStore.agreementId]);
    return (react_1.default.createElement(kaleidoscope_1.Stack, { direction: "horizontal", justify: "center" },
        react_1.default.createElement(kaleidoscope_1.Button, { size: kaleidoscope_1.ButtonSize.Small, type: kaleidoscope_1.ButtonType.Tertiary, onClick: function () {
                openAgreement();
            } },
            react_1.default.createElement(icons_1.Edit, null),
            "Edit agreement"),
        react_1.default.createElement("div", { className: styles.divider }),
        react_1.default.createElement(kaleidoscope_1.Popover, { autoStack: true, padding: "none", size: kaleidoscope_1.PopoverSize.Small, button: function (buttonProps) { return (react_1.default.createElement(kaleidoscope_1.Button, __assign({ type: kaleidoscope_1.ButtonType.Tertiary, size: kaleidoscope_1.ButtonSize.Small, isIconOnly: true }, buttonProps),
                react_1.default.createElement(icons_1.OptionsHorizontal, null))); } }, screen === "options" ? (react_1.default.createElement(AgreementOptionsMenu, { onClickDelete: function () { return setScreen("confirmDelete"); }, openAgreementPicker: openAgreementPicker })) : (react_1.default.createElement(exports.AgreementConfirmDelete, { onConfirm: function () { return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, deleteAgreement()];
                        case 1:
                            _a.sent();
                            return [2];
                    }
                });
            }); }, onCancel: function () { return setScreen("options"); } })))));
});
var AgreementViewButtonComponent = (0, mobx_react_1.observer)(function () {
    var blockList = (0, inversify_react_1.useInjection)("blockList");
    var eventEmitter = (0, inversify_react_1.useInjection)("acceptPreviewEventEmitter");
    var insertBlock = (0, inversify_react_1.useInjection)("insertBlock");
    var usingFeature = (0, inversify_react_1.useInjection)("usingFeature");
    var _a = __read((0, react_1.useState)(false), 2), isAgreementPickerOpen = _a[0], setIsAgreementPickerOpen = _a[1];
    var _b = __read((0, react_1.useState)(false), 2), hasAddedAgreement = _b[0], setHasAddedAgreement = _b[1];
    var blockModel = (0, GetBlockModels_1.getBlockModel)(BlockTypes_1.BlockType.Agreement);
    var _c = useAgreementEditorContext(), isSavedBlocksLibrary = _c.isSavedBlocksLibrary, agreementId = _c.agreementId, openAgreement = _c.openAgreement;
    (0, react_1.useEffect)(function () {
        if (isAgreementPickerOpen) {
            eventEmitter.trigger(AcceptPreviewEventEmitter_1.AcceptPreviewEvent.ClosePreview);
        }
    }, [eventEmitter, isAgreementPickerOpen]);
    (0, react_1.useEffect)(function () {
        if (agreementId && isAgreementPickerOpen && hasAddedAgreement) {
            openAgreement();
            setIsAgreementPickerOpen(false);
            setHasAddedAgreement(false);
        }
    }, [agreementId, isAgreementPickerOpen, hasAddedAgreement]);
    if (isSavedBlocksLibrary && !agreementId) {
        return null;
    }
    var shouldShowPrompt = !!blockList.getFirstBlockOfType(BlockTypes_1.BlockType.Accept) &&
        !!blockList.getFirstBlockOfType(BlockTypes_1.BlockType.Quote) &&
        usingFeature(FeatureFlag_1.default.AgreementFeaturePromptEnabled);
    return (react_1.default.createElement(kaleidoscope_1.Stack, { className: styles.container }, !!agreementId ? (react_1.default.createElement(EditAgreementButton, { openAgreementPicker: function () { return setIsAgreementPickerOpen(true); } })) : (react_1.default.createElement(AddAgreementButton, { shouldShowPrompt: shouldShowPrompt, isAgreementPickerOpen: isAgreementPickerOpen, setIsAgreementPickerOpen: setIsAgreementPickerOpen, onClick: function (event, savedBlock) { return __awaiter(void 0, void 0, void 0, function () {
            var blockToInsert, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        blockToInsert = savedBlock !== null && savedBlock !== void 0 ? savedBlock : blockModel;
                        return [4, insertBlock(function (block) { return __awaiter(void 0, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4, blockList.insertAgreementBlock(block)];
                                        case 1:
                                            _a.sent();
                                            return [2];
                                    }
                                });
                            }); })(blockToInsert)];
                    case 1:
                        _a.sent();
                        setHasAddedAgreement(true);
                        return [3, 3];
                    case 2:
                        error_1 = _a.sent();
                        console.error(error_1.message);
                        return [3, 3];
                    case 3: return [2];
                }
            });
        }); } }))));
});
var AgreementViewButton = (function () {
    function AgreementViewButton(createUi, mountReactComponent, di, $timeout, addDefaultTcdcStyle, block, $state, savedBlockService, telemetry, overlayStack, showDeleteModal) {
        this.ui = createUi(require("Project/Modules/Accept/Controls/Agreement/AgreementButton.html"), {
            $init: function (scope) {
                scope.ui.agreementButton = mountReactComponent(react_1.default.createElement(DIProvider_1.RootDIProvider, { di: di },
                    react_1.default.createElement(DIProvider_1.default, { container: function () {
                            var container = new inversify_1.Container({ skipBaseClassChecks: true });
                            container.bind(AngularSyncStore_1.AngularSyncServices.$).toConstantValue({ $scope: scope, $timeout: $timeout });
                            container.bind(AcceptBlockStore_1.default).toSelf().inSingletonScope();
                            container.bind("acceptPreviewEventEmitter").toConstantValue(di.get("acceptPreviewEventEmitter"));
                            container.bind("addDefaultTcdcStyle").toConstantValue(addDefaultTcdcStyle);
                            return container;
                        } },
                        react_1.default.createElement(exports.AgreementEditorContextProvider, { block: block, navigator: $state.go, savedBlockService: savedBlockService, overlayStack: overlayStack, telemetry: telemetry, "$timeout": $timeout, showDeleteModal: showDeleteModal, projectId: block.projectId },
                            react_1.default.createElement(kaleidoscope_1.Layer, { offset: Configuration_1.overlayStackZIndex }, function () { return react_1.default.createElement(AgreementViewButtonComponent, null); })))));
            },
        });
    }
    return AgreementViewButton;
}());
exports.default = AgreementViewButton;
var AgreementEditorContext = react_1.default.createContext(undefined);
var useAgreementEditorContext = function () {
    var ctx = react_1.default.useContext(AgreementEditorContext);
    if (!ctx) {
        throw new Error("useAgreementEditorContext() must be used within an AgreementEditorContext Provider");
    }
    return ctx;
};
exports.AgreementEditorContextProvider = (0, mobx_react_1.observer)(function (_a) {
    var children = _a.children, block = _a.block, navigator = _a.navigator, savedBlockService = _a.savedBlockService, telemetry = _a.telemetry, overlayStack = _a.overlayStack, $timeout = _a.$timeout, showDeleteModal = _a.showDeleteModal, projectId = _a.projectId;
    var isSavedBlocksLibrary = block.$isSavedBlock;
    var acceptBlockStore = (0, inversify_react_1.useInjection)(AcceptBlockStore_1.default);
    var acceptPreviewEventEmitter = (0, inversify_react_1.useInjection)("acceptPreviewEventEmitter");
    var deleteBlock = (0, inversify_react_1.useInjection)("deleteBlock");
    var notifyUser = (0, inversify_react_1.useInjection)("notifyUser");
    var blockCreator = (0, inversify_react_1.useInjection)("blockCreator");
    var blockFetcher = (0, inversify_react_1.useInjection)("blockFetcher");
    var agreementBlockRef = (0, react_1.useRef)(null);
    var saveOrchestrator = new SaveOrchestrator_1.SaveOrchestrator(block, false, savedBlockService, telemetry, TelemetryEnums_1.SavedBlockOrigin.Dashboard);
    var editActionBarStore = new EditActionBarStore_1.default(block, savedBlockService, saveOrchestrator, overlayStack);
    var openAgreement = isSavedBlocksLibrary
        ? function () { return __awaiter(void 0, void 0, void 0, function () {
            var confirmLeaveWithoutSaving;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!editActionBarStore.hasUnsavedChanges) return [3, 2];
                        return [4, showDeleteModal({
                                title: "Discard changes?",
                                explainer: "You have unsaved changes to this block. Changes will be discarded if you leave without saving.",
                                deleteButton: saveOrchestrator.requiresInitialSave ? "Delete" : "Discard",
                            })];
                    case 1:
                        confirmLeaveWithoutSaving = _a.sent();
                        if (confirmLeaveWithoutSaving) {
                            $timeout(function () {
                                overlayStack.closeCurrent();
                            });
                        }
                        else {
                            return [2];
                        }
                        return [3, 3];
                    case 2:
                        $timeout(function () {
                            overlayStack.closeCurrent();
                        });
                        _a.label = 3;
                    case 3:
                        navigator("savedBlock", {
                            entityId: block.savedAgreement,
                            action: "preview",
                        }, {
                            location: false,
                        });
                        setTimeout(function () {
                            navigator("dashboard", {
                                nav: "blocks",
                            }, {
                                location: "replace",
                            });
                        }, 500);
                        return [2];
                }
            });
        }); }
        : function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                acceptPreviewEventEmitter.trigger(AcceptPreviewEventEmitter_1.AcceptPreviewEvent.OpenPreview);
                return [2];
            });
        }); };
    var deleteAgreement = isSavedBlocksLibrary
        ? function () { return __awaiter(void 0, void 0, void 0, function () {
            var clone;
            return __generator(this, function (_a) {
                clone = (0, lodash_1.cloneDeep)(block);
                clone.savedAgreement = "";
                savedBlockService.update(clone, TelemetryEnums_1.SavedBlockOrigin.Dashboard);
                acceptBlockStore.savedAgreement = null;
                return [2];
            });
        }); }
        : function () { return __awaiter(void 0, void 0, void 0, function () {
            var block_1, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!acceptBlockStore.agreementId) {
                            return [2];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4, blockFetcher.fetchBlockById(projectId, acceptBlockStore.agreementId)];
                    case 2:
                        block_1 = _a.sent();
                        if (block_1.type === BlockTypes_1.BlockType.Agreement) {
                            agreementBlockRef.current = block_1;
                        }
                        return [3, 4];
                    case 3:
                        error_2 = _a.sent();
                        console.error("Error fetching agreement block:", error_2);
                        return [3, 4];
                    case 4: return [4, deleteBlock({ type: BlockTypes_1.BlockType.Agreement, _id: acceptBlockStore.agreementId })];
                    case 5:
                        _a.sent();
                        acceptBlockStore.agreementId = null;
                        notifyUser.success(react_1.default.createElement(react_1.default.Fragment, null,
                            "Agreement deleted",
                            " ",
                            react_1.default.createElement(kaleidoscope_1.Button, { key: "delete-agreement-notification", onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                                    var clonedBlockId;
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0:
                                                if (!acceptBlockStore.agreementId) return [3, 2];
                                                return [4, deleteBlock({ type: BlockTypes_1.BlockType.Agreement, _id: acceptBlockStore.agreementId })];
                                            case 1:
                                                _a.sent();
                                                acceptBlockStore.agreementId = null;
                                                _a.label = 2;
                                            case 2:
                                                if (!agreementBlockRef.current) return [3, 4];
                                                return [4, blockCreator.cloneBlock(agreementBlockRef.current)];
                                            case 3:
                                                clonedBlockId = _a.sent();
                                                acceptBlockStore.agreementId = clonedBlockId;
                                                agreementBlockRef.current = null;
                                                _a.label = 4;
                                            case 4: return [2];
                                        }
                                    });
                                }); } }, "Undo")));
                        return [2];
                }
            });
        }); };
    return (react_1.default.createElement(AgreementEditorContext.Provider, { value: {
            navigator: navigator,
            isSavedBlocksLibrary: isSavedBlocksLibrary,
            agreementId: acceptBlockStore.agreementId,
            openAgreement: openAgreement,
            deleteAgreement: deleteAgreement,
        } }, children));
});
